






const sharedCSS = `
  .email-container {
    max-width: 600px;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  }
  .header {
    background: linear-gradient(135deg, #b79bf8 0%, #8a5cf6 100%);
    color: white;
    text-align: center;
    padding: 8px 30px;
  }
  .header-title {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 8px;
  }
  .content {
    padding: 30px;
  }
  /* List styling */
  .content ul {
    margin: 16px 0 16px 20px;
    padding: 0;
    list-style-type: disc;
  }
  .content ul li {
    margin-bottom: 8px;
  }
  .divider {
    height: 4px;
    background: linear-gradient(90deg, #8a5cf6 0%, #b79bf8 100%);
    margin: 25px 0;
    border-radius: 2px;
  }
  .highlight-box {
    background-color: #f0f7ff;
    border-left: 4px solid #4a90e2;
    padding: 20px;
    border-radius: 0 8px 8px 0;
    margin: 25px 0;
  }
  .cta-button {
    display: inline-block;
    background: linear-gradient(135deg, #8a5cf6 0%, #6d28d9 100%);
    color: white;
    text-decoration: none;
    padding: 14px 28px;
    border-radius: 30px;
    font-size: 16px;
    font-weight: 600;
    margin: 20px 0;
    box-shadow: 0 4px 12px rgba(109, 40, 217, 0.2);
    transition: all 0.3s ease;
  }
  .cta-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(109, 40, 217, 0.3);
  }
  .footer {
    background-color: #f0e9ff;
    text-align: center;
    padding: 20px;
    font-size: 14px;
    color: #666;
  }
  .bold {
    font-weight: 600;
  }
  .text-center {
    text-align: center;
  }
    .gratitude{
    margin-top:15px
    }
 .otp-body{

      display: flex;
      justify-content: center;


    }
  .otp-container {
  border: 1px solid #ccc;
  text-align: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #f9f9f9;
  max-width: 400px;
  width: 100%;
  margin-top: 20px;
}


        .otp-title {
            font-size: 18px;
            font-weight: bold;
            color: #333;
            margin-bottom: 8px;
        }

        .otp-instruction {
            font-size: 14px;
            color: #666;

        }

        .otp-code {
            font-size: 28px;
            font-weight: bold;
            letter-spacing: 5px;
            color: #000;

padding:15px
            border-radius: 5px;
            display: inline-block;
        }
`;

const otpSection = `
 <div class="otp-container">
        <div class="otp-title">Assessment OTP</div>
        <div class="otp-instruction">Please use the following OTP while conducting your assessment:</div>
        <div class="otp-code">767727</div>
    </div>`;

const sharedFooter = `
  <!-- Footer -->
  <div class="footer">
    <p>Get ready to transform your workflow with<br/><strong>mytruestrength.com</strong></p>
    <p>© {Company Name} All rights reserved.</p>
  </div>
`;

export const template = [
  {
    id: 1,
    name: "Template One",
    content: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>AI That Empowers, Not Replaces</title>
  <style>${sharedCSS}</style>
</head>
<body>
  <div class="email-container">
    <div class="header">
      <div class="header-title">AI That Empowers, Not Replaces</div>
      <p>We're Not Using AI to Replace You — We're Using It to Elevate You</p>
    </div>
    <div class="content">
      <p>Hello,</p>
      <p>
        AI is transforming how companies operate — but at
        <span class="bold">{Company Name}</span>, we're clear about one thing:
      </p>
      <div class="highlight-box">
        We're not using AI to reduce our people.<br />
        We're using it to reveal your full potential.
      </div>
      <p>
        You're invited to take a short,
        <span class="bold">AI-powered personality test</span> that helps us
        understand how you work best — so we can align roles,
        responsibilities, and growth paths that truly fit you.
      </p>
      <div class="divider"></div>
      <p class="bold">
        We're aiming for 5x growth — and we want to do it with you, not around
        you.
      </p>
      
      <div class="text-center">
        <a href="{assessment_url}" class="cta-button">Take Your Test Here</a>
      </div>
      <p>
        This is about <span class="bold">enhancement, not evaluation</span>.
        <span class="bold">Empowerment, not automation</span>.
      </p>
      <p>Thanks for being part of the future we're building — together.</p>
      <p class="gratitude">
        Warmly,<br />

        {Company Name}
      </p>
    </div>
    ${sharedFooter}
  </div>
</body>
</html>`,
  },
  {
    id: 2,
    name: "Template Two",
    content: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Grow Smarter with AI | SelfsyncAi</title>
  <style>${sharedCSS}</style>
</head>
<body>
  <div class="email-container">
    <div class="header">
      <div class="header-title">Grow Smarter with AI</div>
      <p>We’re Using AI to Unlock What’s Already Great About You</p>
    </div>
    <div class="content">
      <p>Hello,</p>
      <p>At <span class="bold">{Company Name}</span>, we believe our biggest advantage isn’t tech. It’s <span class="bold">you</span>.</p>
      <p>We’re bringing AI into our organization — not to replace talent, but to amplify it.</p>
      <div class="highlight-box">
        <div class="highlight-title">This 45-minute AI-powered personality test helps us understand how to:</div>
        <ul>
          <li>Align you to the right work</li>
          <li>Support your growth with tailored feedback</li>
          <li>Unlock team productivity in a deeply human way</li>
        </ul>
      </div>
      <p>Our goal is <span class="bold">5x growth</span> — and we want you to scale with us.</p>
      
      <div class="text-center">
        <a href="{assessment_url}" class="cta-button">Take the Test Now</a>
      </div>
      <div class="divider"></div>
      <p style="text-align:center; font-size:15px; color:#777;">If the button above doesn't work, copy and paste this URL into your browser:<br /><span style="word-break:break-all; font-size:13px; color:#6d28d9;">{assessment_url}</span></p>

         <p class="gratitude">
        Warmly,<br />

        {Company Name}
      </p>
    </div>

    ${sharedFooter}
  </div>
</body>
</html>`,
  },
  {
    id: 3,
    name: "Template Three",
    content: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>AI to Unlock the Best Version of You</title>
  <style>${sharedCSS}</style>
</head>
<body>
  <div class="email-container">
    <div class="header">
      <div class="header-title">AI to Unlock the Best Version of You</div>
      <p>You're a Key Part of Our 5x Growth Plan</p>
    </div>
    <div class="content">
      <p>Hello,</p>
      <p>Every company talks about using AI for productivity.</p>
      <div class="highlight-box">
        But at {Company Name}, we believe real productivity comes from people doing work they actually enjoy and excel at.
      </div>
      <p>This 45-minute, <span class="bold">AI-powered personality test</span> helps us do exactly that: Understand you better, so we can support you smarter.</p>
      <div class="divider"></div>
      <p class="bold">We're not using AI to cut jobs.<br />We're using it to align roles, reduce burnout, and help you grow faster — as we aim for 5x scale together.</p>
      
      <div class="text-center">
        <a href="{assessment_url}" class="cta-button">Start your test here</a>
      </div>
      <p><span class="bold">We grow when you grow.</span> Let's unlock what's next — together.</p>
      <p class="gratitude">Warmly,<br />{Company Name}</p>
    </div>
    ${sharedFooter}
  </div>
</body>
</html>`,
  },
];

export const customTemplate = {
    id: 4,
    name: "Custom Template",
    content: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Grow Smarter with AI | SelfsyncAi</title>
  <style>${sharedCSS}</style>
</head>
<body>
  <div class="email-container">
    <div class="header">
      <div class="header-title">{header}</div>
      <p>{sub_header}</p>
    </div>
    <div class="content">
      <p>Hello,</p>
      <p>{content}</p>
      
      <div class="text-center">
        <a href="{assessment_url}" class="cta-button">Take the Test Now</a>
      </div>
      <div class="divider"></div>
      <p style="text-align:center; font-size:15px; color:#777;">If the button above doesn't work, copy and paste this URL into your browser:<br /><span style="word-break:break-all; font-size:13px; color:#6d28d9;">{assessment_url}</span></p>
        <p>{closing_statement}</p>
         <p class="gratitude">Warmly,<br />{Company Name}</p>
    </div>

    ${sharedFooter}
  </div>
</body>
</html>`
}
